import Badge from '../Badges';
import { useTranslate } from '../../../../shared/hooks/useTranslate';
import { UserOrder } from '../../types/users';

interface Props {
	status:
		| UserOrder['status']
		| UserOrder['payment_method']
		| 'completed_by'
		| 'created_by';
}

const OrderStatusBadge = ({ status }: Props) => {
	const { __ } = useTranslate();
	const getHumanStatus = (status: string): string => {
		switch (status) {
			case 'completed':
				return __('Completed');
			case 'awaiting_payment':
				return __('Awaiting payment');
			case 'refunded':
				return __('Refunded');
			case 'partially_refunded':
				return __('partially refunded');
			case 'cancelled':
				return __('Cancelled');
			case 'created':
				return __('In cart');
			default:
				return status;
		}
	};

	const getHumanPaymentMethod = (method: string): string => {
		switch (method) {
			case 'online_transfer':
				return __('Online payment');
			case 'other':
				return __('Other');
			default:
				return method;
		}
	};

	switch (status) {
		case 'completed':
			return <Badge type="success">{getHumanStatus(status)}</Badge>;
		case 'refunded':
			return <Badge type="warning">{getHumanStatus(status)}</Badge>;
		case 'cancelled':
			return <Badge type="error">{getHumanStatus(status)}</Badge>;
		case 'created':
			return <Badge type="info">{getHumanStatus(status)}</Badge>;
		case 'awaiting_payment':
			return <Badge type="warning">{getHumanStatus(status)}</Badge>;
		case 'partially_refunded':
			return <Badge type="warning">{getHumanStatus(status)}</Badge>;
		case 'other':
			return <Badge type="default">{getHumanPaymentMethod(status)}</Badge>;
		case 'online_transfer':
			return <Badge type="default">{getHumanPaymentMethod(status)}</Badge>;
		case 'completed_by':
			return <Badge type="info">{__('Completed by organizer')}</Badge>;
		case 'created_by':
			return <Badge type="info">{__('Created by organizer')}</Badge>;
		default:
			return <Badge type="default">{status}</Badge>;
	}
};

export default OrderStatusBadge;
